import React from 'react';
import { Radio } from '../../radio';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons';

interface Option {
  value: string;
  label: string;
}

interface RadioGroupProps {
  title?: string;
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  otherOptions?: Option[];
}

const AddSeriesRadioGroup: React.FC<RadioGroupProps> = (props) => {
  const { title, options, value, onChange, className, otherOptions } = props;

  const hasOtherOptions = otherOptions && otherOptions.length > 0;

  const isOtherSelected =
    (hasOtherOptions && !!otherOptions.find((option) => option.value === value)) || false;

  const selectedLabel = otherOptions?.find((option) => option.value === value)?.label;

  const renderOtherOptions = () => {
    return (
      <Radio
        key={'other'}
        label={isOtherSelected ? selectedLabel : '...'}
        checked={isOtherSelected}
        onChange={() => {
          if (otherOptions && otherOptions.length > 0) {
            onChange(otherOptions[0].value);
          }
        }}
        className={classNames('group-option', 'other-option', {
          'other-selected': isOtherSelected,
        })}
        rightIcon={<FontAwesomeIcon icon={faAngleRight} className="right-icon" />}
      />
    );
  };

  return (
    <div className={`add-series-radio-group ${className}`}>
      {title && <span className="add-series-radio-group-title">{title}</span>}
      <div className="add-series-radio-group-options">
        {options.map((option) => (
          <Radio
            key={option.value}
            label={option.label}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
            className="group-option"
          />
        ))}
        {hasOtherOptions && renderOtherOptions()}
      </div>
    </div>
  );
};

export default AddSeriesRadioGroup;
